export const CONSTANTS = {
  CONTENT_BASEURL: 'content-baseurl',
  PREFIX: 'prefix',
  TOTAL: 'total',
  RESOURCES: 'resources',
  RESOURCE: {
    ATTRIBUTE: 'attribute',
    BASKET: 'basket',
    CATALOG: 'catalog',
    CUSTOMER: 'customer',
    COMPARE: 'compare',
    LOCALE: 'locale',
    ORDER: 'order',
    PRODUCT: 'product',
    SERVICE: 'service',
    STOCK: 'stock',
    SUPPLIER: 'supplier',
    SKU: 'sku',
    SPAREPARTS: 'spareparts',
  },
  LOCALE: {
    TYPE: 'locale',
    CURRENCYID: 'currencyid',
    ID: 'id',
    LANGUAGEID: 'languageid',
    POSITION: 'position',
    SITEID: 'siteid',
    STATUS: 'status',
  },
}

export const PATHS = {
  CONTENT_BASEURL: [CONSTANTS.CONTENT_BASEURL],
  PREFIX: [CONSTANTS.PREFIX],
  TOTAL: [CONSTANTS.TOTAL],
  RESOURCES: [CONSTANTS.RESOURCES],
  ATTRIBUTE: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.ATTRIBUTE],
  BASKET: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.BASKET],
  CATALOG: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.CATALOG],
  CUSTOMER: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.CUSTOMER],
  COMPARE: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.COMPARE],
  LOCALE: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.LOCALE],
  ORDER: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.ORDER],
  PRODUCT: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.PRODUCT],
  SERVICE: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.SERVICE],
  STOCK: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.STOCK],
  SUPPLIER: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.SUPPLIER],
  SKU: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.SKU],
  SPAREPARTS: [CONSTANTS.RESOURCES, CONSTANTS.RESOURCE.SPAREPARTS],
}

export default {
  ...CONSTANTS,
  PATHS,
}
